import { userActions } from "../../actionTypes";
import { resendVerificationEmail } from "../../../api/libs/user";
import toast from "react-hot-toast";

export const resendEmail = newEmail => {
	return async dispatch => {
		dispatch({
			type: userActions.RESEND_EMAIL,
		});
		resendVerificationEmail(newEmail)
			.then(res => {
				if (res.success) {
					dispatch({
						type: userActions.RESEND_FULLFILLED,
					});
					toast.success("Email sent!");
				}
			})
			.catch(err => {
				dispatch({
					type: userActions.RESEND_REJECTED,
					payload: err.response,
				});
			});
	};
};
